export default {"container":"wTB1Q","promoCodeItem":"_2MpER","promoCodeItemText":"wLBBX","selected":"Cl7z9","bookieLogo":"HvDze"};